<template>
	<product-landing-page :page-name="pageName" />
</template>
<script>
import ProductLandingPage from './components/ProductLandingPage';
import PublicStore from '@/mixins/PublicStore';

export default {
	name: 'TuunLandingPage',
	components: {
		ProductLandingPage,
	},
	mixins: [PublicStore],
	data() {
		return {
			pageName: this.$route.fullPath.split('/')[2],
		};
	},
	created() {
		if (!this.showPublicStore) {
			this.$router.replace({ name: 'Store' }).catch(() => {});
		}
	},
};
</script>
